"use strict";

jQuery(function ($) {
  const POPUP_SELECTOR = ".popup";

  let initialized = false;
  let previousScrollY = window.scrollY;
  let scrollDirection = "down";

  function hasPopups(scope) {
    const root = scope || document;

    return Boolean(
      root.matches?.(POPUP_SELECTOR) ||
      root.querySelector?.(POPUP_SELECTOR)
    );
  }

  function getPopup(element) {
    return $(element).closest(POPUP_SELECTOR);
  }

  function getCookie(name) {
    const matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(
            /([\.$?*|{}\(\)\[\]\\\/\+^])/g,
            "\\$1"
          ) +
          "=([^;]*)"
      )
    );

    return matches
      ? decodeURIComponent(matches[1])
      : undefined;
  }

  function getStorage(key) {
    const item = localStorage.getItem(key);

    if (item) {
      try {
        const parsed = JSON.parse(item);

        if (
          parsed.expires &&
          Date.now() > parsed.expires
        ) {
          localStorage.removeItem(key);
          return undefined;
        }

        return parsed.value;
      } catch (error) {
        return undefined;
      }
    }

    const cookieValue = getCookie(key);

    if (cookieValue !== undefined) {
      setStorage(key, cookieValue);
      return cookieValue;
    }

    return undefined;
  }

  function setStorage(key, value, options = {}) {
    const data = {
      value: value,
      expires: null
    };

    if (options.expires) {
      const expiresDate = new Date();

      expiresDate.setDate(
        expiresDate.getDate() +
          parseInt(options.expires, 10)
      );

      data.expires = expiresDate.getTime();
    }

    localStorage.setItem(
      key,
      JSON.stringify(data)
    );
  }

  function getScrollPercent() {
    const documentElement =
      document.documentElement;

    const body = document.body;

    const scrollTop =
      documentElement.scrollTop ||
      body.scrollTop;

    const scrollHeight =
      documentElement.scrollHeight ||
      body.scrollHeight;

    const availableHeight =
      scrollHeight -
      documentElement.clientHeight;

    if (availableHeight <= 0) {
      return 0;
    }

    return (
      (scrollTop / availableHeight) *
      100
    );
  }

  function applyAnimation(
    element,
    animationName,
    callback
  ) {
    const popup = getPopup(element);

    const overlayAnimation =
      typeof callback === "function"
        ? "popupExitFade"
        : "popupOpenFade";

    popup
      .next(".popup-overlay")
      .addClass(
        "popup-animated " +
          overlayAnimation
      )
      .one(
        "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
        function () {
          $(this).removeClass(
            "popup-animated " +
              overlayAnimation
          );
        }
      );

    const popupWrap =
      popup.find(".popup-wrap");

    if (!popupWrap.length) {
      if (
        typeof callback === "function"
      ) {
        callback();
      }

      return;
    }

    popupWrap
      .addClass(
        "popup-animated " +
          animationName
      )
      .one(
        "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
        function () {
          $(this).removeClass(
            "popup-animated " +
              animationName
          );

          if (
            typeof callback ===
            "function"
          ) {
            callback();
          }
        }
      );
  }

  function closePopup(element) {
    const popup = getPopup(element);

    if (!popup.length) {
      return;
    }

    const animation =
      popup.data("exit-animation");

    applyAnimation(
      popup,
      animation,
      function () {
        popup.addClass(
          "popup-already-opened"
        );

        popup.removeClass(
          "popup-open"
        );

        $("body").removeClass(
          "popup-scroll-hidden"
        );
      }
    );
  }

  function closeTriggerPopup(popupElement) {
    const popup = $(popupElement);

    const trigger =
      popup.data("close-trigger");

    if (trigger === "delay") {
      const delay =
        Number(
          popup.data(
            "close-delay-number"
          )
        ) || 0;

      window.setTimeout(
        function () {
          closePopup(popup);
        },
        delay * 1000
      );
    }

    if (trigger === "scroll") {
      const scrollType =
        popup.data(
          "close-scroll-type"
        );

      const scrollPosition =
        Number(
          popup.data(
            "close-scroll-position"
          )
        ) || 0;

      const initialScrollPx =
        Number(
          popup.data(
            "init-scroll-px"
          )
        ) || 0;

      const initialScrollPercent =
        Number(
          popup.data(
            "init-scroll-percent"
          )
        ) || 0;

      $(document)
        .off(
          "scroll.adpPopupClose",
          popupElement
        )
        .on(
          "scroll.adpPopupClose",
          popupElement,
          function () {
            if (scrollType === "px") {
              if (
                scrollDirection ===
                  "up" &&
                window.scrollY <
                  initialScrollPx -
                    scrollPosition
              ) {
                closePopup(popup);
              }

              if (
                scrollDirection ===
                  "down" &&
                window.scrollY >=
                  initialScrollPx +
                    scrollPosition
              ) {
                closePopup(popup);
              }
            }

            if (scrollType === "%") {
              const currentPercent =
                getScrollPercent();

              if (
                scrollDirection ===
                  "up" &&
                currentPercent <
                  initialScrollPercent -
                    scrollPosition
              ) {
                closePopup(popup);
              }

              if (
                scrollDirection ===
                  "down" &&
                currentPercent >=
                  initialScrollPercent +
                    scrollPosition
              ) {
                closePopup(popup);
              }
            }
          }
        );
    }
  }

  function openPopup(element) {
    const popup = getPopup(element);

    if (!popup.length) {
      return;
    }

    if (
      popup.hasClass("popup-open") ||
      popup.hasClass(
        "popup-already-opened"
      )
    ) {
      return;
    }

    if (
      popup.is(
        '[data-body-scroll-disable="true"]'
      )
    ) {
      $("body").addClass(
        "popup-scroll-hidden"
      );
    }

    const storageKey =
      "popup-" +
      (popup.data("id") || 0);

    const currentLimit =
      parseInt(
        getStorage(storageKey) || 0,
        10
      ) + 1;

    setStorage(
      storageKey,
      currentLimit,
      {
        expires:
          popup.data(
            "limit-lifetime"
          )
      }
    );

    popup.addClass("popup-open");

    popup.data(
      "init-scroll-px",
      window.scrollY
    );

    popup.data(
      "init-scroll-percent",
      getScrollPercent()
    );

    applyAnimation(
      popup,
      popup.data("open-animation")
    );

    closeTriggerPopup(
      popup.get(0)
    );
  }

  function isPopupAllowed(popupElement) {
    const popup = $(popupElement);

    const limit =
      parseInt(
        popup.data(
          "limit-display"
        ) || 0,
        10
      );

    const storageValue =
      parseInt(
        getStorage(
          "popup-" +
            (popup.data("id") || 0)
        ) || 0,
        10
      );

    if (
      limit &&
      storageValue >= limit
    ) {
      return false;
    }

    return true;
  }

  function openTriggerPopup(
    popupElement
  ) {
    const popup = $(popupElement);

    const trigger =
      popup.data("open-trigger");

    if (trigger === "none") {
      const ageVerification =
        getStorage(
          "popup-age-" +
            (popup.data("id") || 0)
        );

      if (!ageVerification) {
        openPopup(popup);
      }
    }

    if (trigger === "delay") {
      const delay =
        Number(
          popup.data(
            "open-delay-number"
          )
        ) || 0;

      window.setTimeout(
        function () {
          openPopup(popup);
        },
        delay * 1000
      );
    }

    if (trigger === "exit") {
      let mayOpen = true;

      $(document)
        .off(
          "mousemove.adpPopupExit",
          popupElement
        )
        .on(
          "mousemove.adpPopupExit",
          popupElement,
          function (event) {
            const scroll =
              window.pageYOffset ||
              document.documentElement
                .scrollTop;

            if (
              event.pageY - scroll <
                7 &&
              mayOpen
            ) {
              openPopup(popup);
              mayOpen = false;
            }
          }
        );
    }

    if (trigger === "scroll") {
      const scrollType =
        popup.data(
          "open-scroll-type"
        );

      const scrollPosition =
        Number(
          popup.data(
            "open-scroll-position"
          )
        ) || 0;

      $(document)
        .off(
          "scroll.adpPopupOpen",
          popupElement
        )
        .on(
          "scroll.adpPopupOpen",
          popupElement,
          function () {
            if (
              scrollType === "px" &&
              window.scrollY >=
                scrollPosition
            ) {
              openPopup(popup);
            }

            if (
              scrollType === "%" &&
              getScrollPercent() >=
                scrollPosition
            ) {
              openPopup(popup);
            }
          }
        );
    }

    if (trigger === "accept") {
      const accepted =
        getStorage(
          "popup-accept-" +
            (popup.data("id") || 0)
        );

      if (!accepted) {
        openPopup(popup);
      }
    }
  }

  function initializePopup(
    popupElement
  ) {
    const popup = $(popupElement);

    if (
      popup.data(
        "adp-popup-initialized"
      )
    ) {
      return;
    }

    popup.data(
      "adp-popup-initialized",
      true
    );

    if (
      popup.data("open-trigger") ===
      "manual"
    ) {
      const selector =
        popup.data(
          "open-manual-selector"
        );

      if (selector) {
        $(selector).addClass(
          "popup-trigger"
        );

        $(document)
          .off(
            "click.adpPopupManual",
            selector
          )
          .on(
            "click.adpPopupManual",
            selector,
            function (event) {
              event.preventDefault();

              popup.removeClass(
                "popup-already-opened"
              );

              openPopup(popup);
            }
          );
      }
    }

    if (
      !isPopupAllowed(
        popupElement
      ) &&
      !popup.hasClass(
        "age-verification"
      )
    ) {
      return;
    }

    openTriggerPopup(
      popupElement
    );
  }

  function initializePopups(scope) {
    const root = scope || document;

    if (!hasPopups(root)) {
      return;
    }

    if (
      root.matches?.(POPUP_SELECTOR)
    ) {
      initializePopup(root);
    }

    root
      .querySelectorAll?.(
        POPUP_SELECTOR
      )
      .forEach(
        initializePopup
      );
  }

  function initializeGlobalEvents() {
    if (initialized) {
      return;
    }

    initialized = true;

    $(document)
      .off(".adpPopupGlobal")
      .on(
        "click.adpPopupGlobal",
        ".popup-close",
        function () {
          closePopup(this);
        }
      )
      .on(
        "click.adpPopupGlobal",
        ".popup-accept",
        function () {
          const popup =
            getPopup(this);

          setStorage(
            "popup-accept-" +
              (popup.data("id") ||
                0),
            1,
            {
              expires: 360
            }
          );

          closePopup(this);
        }
      )
      .on(
        "click.adpPopupGlobal",
        ".age-verification__popup-close",
        function () {
          const popup =
            getPopup(this);

          setStorage(
            "popup-age-" +
              (popup.data("id") ||
                0),
            1,
            {
              expires: 360
            }
          );

          closePopup(this);
        }
      )
      .on(
        "click.adpPopupGlobal",
        ".age-verification__button-no",
        function () {
          $(
            ".age-verification__question"
          ).removeClass("show");

          $(
            ".age-verification__declined"
          ).addClass("show");
        }
      )
      .on(
        "click.adpPopupGlobal",
        ".popup-overlay",
        function () {
          $(
            '.popup-open[data-overlay-close="true"]'
          ).each(function () {
            closePopup(this);
          });
        }
      )
      .on(
        "keyup.adpPopupGlobal",
        function (event) {
          if (
            event.key === "Escape"
          ) {
            $(
              '.popup-open[data-esc-close="true"]'
            ).each(function () {
              closePopup(this);
            });
          }

          if (event.key === "F4") {
            $(
              '.popup-open[data-f4-close="true"]'
            ).each(function () {
              closePopup(this);
            });
          }
        }
      )
      .on(
        "scroll.adpPopupDirection",
        function () {
          const currentScrollY =
            window.scrollY;

          scrollDirection =
            currentScrollY >
            previousScrollY
              ? "down"
              : "up";

          previousScrollY =
            currentScrollY;
        }
      );
  }

  /*
   * Auf Seiten ohne Popup wird kein globaler Scroll-, Klick-
   * oder Tastatur-Listener eingerichtet.
   */
  if (hasPopups(document)) {
    initializeGlobalEvents();
    initializePopups(document);
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      if (!hasPopups(event.target)) {
        return;
      }

      initializeGlobalEvents();
      initializePopups(event.target);
    }
  );

  document.addEventListener(
    "shopify:section:unload",
    function () {
      $("body").removeClass(
        "popup-scroll-hidden"
      );
    }
  );
});